export const pageContainerStyle = "flex flex-col w-full min-h-full";
export const pageContentStyle = "flex flex-col w-full max-w-[640px] mx-auto";
